import { OptionType } from "../../shared/components/BaseAsyncPaginate";
import { createLoadOptions } from "../../service/createLoadOptions";
import {
  Distributor,
  GetDistributorsResponse,
} from "../models/response/get-distributors-response";
import { getPaginatedByNameDistributors } from "./distributor-service";

const fetchDistributors = async (
  page: number,
  perPage: number,
  searchQuery?: string
): Promise<GetDistributorsResponse> => {
  return getPaginatedByNameDistributors({ page, perPage, searchQuery });
};

const distributorMapper = (spec: Distributor): OptionType => ({
  value: spec.id,
  label: `${spec.contactName} @ ${spec.name}`,
});

export const loadDistributors = createLoadOptions(
  fetchDistributors,
  distributorMapper
);
